import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../shared/components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import TableAffairComplaint from './TableAffairComplaint';
import Spinner from 'react-bootstrap/Spinner';

const ModalAffairComplaint = ({ closeModal, opened, affairsData, Callback }) => {

    //Articulos
    const [affair, setAffair] = useState(null);
    const [loading, setLoading] = useState([]);

    useEffect(() => {

    }, []);

    const handleAffair = (value) => {
        setAffair(value);
    }

    const addAffair = async () => {
        if (affair != null && affair != undefined && affair != "") {
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'quejas-reclamos-asunto/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({
                    queja_asunto: affair
                })
            }).then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
                else {
                    throw new Error('Data');
                }
            }).then(data => {
                reload();
                closeModal();
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    const reload = () => {
        setLoading(true);
        Callback();
        setLoading(false);
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Asuntos</h5>
                        </div>
                        <Row>
                            <Col md={10}>
                                <TextField
                                    label="Asunto"
                                    value={affair}
                                    onChange={(event) => {
                                        handleAffair(event.target.value);
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={2}>
                                <br />
                                <Button
                                    variant="contained"
                                    className="btn btn-primary btn-sm text-white"
                                    onClick={() => {
                                        addAffair();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                            </Col>

                            {loading == false ? <TableAffairComplaint reactTableData={affairsData} /> :
                                <div className="text-center">
                                    <Spinner animation="border" variant="success" />
                                </div>}

                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default ModalAffairComplaint;
